/* eslint-disable indent */
import { memo } from 'react'
import { Box, Card, Heading, Link, Tooltip } from '@chakra-ui/react'
import { Lock, KeySimple } from 'components/icons'
import {
  INSTITUTIONAL_MANAGEMENT_URL,
  APP_CITIZEN_URL,
  ALERTS_OF_VULNERABILITY_URL,
  CITIZEN_PORTAL_URL,
  CITIZEN_PROFILE_URL,
  SERVICES_LETTER_URL,
  ACTIVITIES_URL,
  ATTENDANCE_URL,
  DATA_INTEGRATOR_URL,
  REGULATION_URL,
  SCHEDULES_URL,
  DIGITAL_ARCHIVE_URL,
  INVENTORY_URL,
  GEO_URL,
  PROCESSES_AND_DOCUMENTS_URL,
  MESSENGER_URL,
  OBSERVATORY_URL,
  UNIFIED_LOGIN_URL,
  SOCIAL_MANAGER_URL,
  ASSESSMENTS_AND_RESEARCH_URL,
  CAREHUB_URL,
} from 'constants/urls'
import {
  AppCitizenModuleBrand,
  VulnerabilityAlertsModuleBrand,
  InstitutionalManagementModuleBrand,
  CitizenProfileModuleBrand,
  ServicesLetterModuleBrand,
  ActivitiesModuleBrand,
  AttendanceModuleBrand,
  DataIntegratorModuleBrand,
  CitizenPortalModuleBrand,
  RegulationModuleBrand,
  SchedulesModuleBrand,
  DigitalArchiveModuleBrand,
  InventoryModuleBrand,
  GeoModuleBrand,
  ProcessesAndDocumentsModuleBrand,
  MessengerModuleBrand,
  ObservatoryModuleBrand,
  UnifiedLoginModuleBrand,
  SocialManagerModuleBrand,
  AssessmentsAndResearchModuleBrand,
} from 'components'
import { DEFAULT_MODULES_IN_THE_API } from 'constants/variables'
import { usePersonalization } from 'contexts/Personalization/Provider'
import { useUserPermissionsManager } from 'contexts/UserPermissionsManager/Provider'

interface ModuleCardProps {
  moduleSlug: string
  showDefaultCard?: boolean
}

const modules: any = {
  activity: {
    label: 'Atividades',
    moduleName: 'ACTIVITIES',
    moduleNameInAPI: 'ACTIVITY',
    href: ACTIVITIES_URL.split('.me')[1],
    Brand: <ActivitiesModuleBrand size={10} />,
  },
  admin: {
    label: 'Gestão Institucional',
    moduleName: 'INSTITUTIONAL_MANAGEMENT',
    moduleNameInAPI: 'ADMIN',
    href: INSTITUTIONAL_MANAGEMENT_URL.split('.me')[1],
    Brand: <InstitutionalManagementModuleBrand size={10} />,
  },
  alert: {
    label: 'Alertas de vulnerabilidade',
    moduleNameInAPI: 'ALERT',
    href: ALERTS_OF_VULNERABILITY_URL.split('.me')[1],
    Brand: <VulnerabilityAlertsModuleBrand size={10} />,
  },
  archive: {
    label: 'Acervo digital',
    moduleNameInAPI: 'ARCHIVE',
    href: DIGITAL_ARCHIVE_URL.split('.me')[1],
    Brand: <DigitalArchiveModuleBrand size={10} />,
  },
  attendance: {
    label: 'Atendimento',
    moduleNameInAPI: 'ATTENDANCE',
    href: ATTENDANCE_URL.split('.me')[1],
    Brand: <AttendanceModuleBrand size={10} />,
  },
  dashboard: {
    label: 'Observatório',
    moduleNameInAPI: 'DASHBOARD',
    href: OBSERVATORY_URL.split('.me')[1],
    Brand: <ObservatoryModuleBrand size={10} />,
  },
  document: {
    label: 'Processos e Documentos',
    moduleNameInAPI: 'DOCS',
    href: PROCESSES_AND_DOCUMENTS_URL.split('.me')[1],
    Brand: <ProcessesAndDocumentsModuleBrand size={10} />,
  },
  geo: {
    label: 'Geo',
    moduleNameInAPI: 'GEO',
    moduleName: 'GEO',
    href: GEO_URL.split('.me')[1],
    Brand: <GeoModuleBrand size={10} />,
  },
  integrated_profile: {
    label: 'Perfil Cidadão',
    moduleNameInAPI: 'INTEGRATED_PROFILE',
    href: CITIZEN_PROFILE_URL.split('.me')[1],
    Brand: <CitizenProfileModuleBrand size={10} />,
  },
  integrator: {
    label: 'Integrador de Dados',
    moduleName: 'DATA_INTEGRATOR',
    moduleNameInAPI: 'INTEGRATOR',
    href: DATA_INTEGRATOR_URL.split('.me')[1],
    Brand: <DataIntegratorModuleBrand size={10} />,
  },
  login: {
    label: 'Login Unificado',
    href: UNIFIED_LOGIN_URL.split('.me')[1],
    Brand: <UnifiedLoginModuleBrand size={10} />,
  },
  messenger: {
    label: 'Mensageria',
    moduleName: 'MESSENGER',
    moduleNameInAPI: 'MESSENGER',
    href: MESSENGER_URL.split('.me')[1],
    Brand: <MessengerModuleBrand size={10} />,
  },
  object: {
    label: 'Estoque',
    moduleName: 'INVENTORY',
    moduleNameInAPI: 'OBJECT',
    href: INVENTORY_URL.split('.me')[1],
    Brand: <InventoryModuleBrand size={10} />,
  },
  portal: {
    label: 'Portal Cidadão',
    href: CITIZEN_PORTAL_URL.split('.me')[1],
    Brand: <CitizenPortalModuleBrand size={10} />,
  },
  profile: {
    label: 'App Cidadão',
    moduleName: 'CITIZEN_PROFILE',
    href: APP_CITIZEN_URL.split('.me')[1],
    Brand: <AppCitizenModuleBrand size={10} />,
  },
  regulation: {
    label: 'Regulação',
    moduleName: 'REGULATION',
    moduleNameInAPI: 'REGULATION',
    href: REGULATION_URL.split('.me')[1],
    Brand: <RegulationModuleBrand size={10} />,
  },
  schedule: {
    label: 'Agendas',
    moduleName: 'SCHEDULE',
    moduleNameInAPI: 'SCHEDULE',
    href: SCHEDULES_URL.split('.me')[1],
    Brand: <SchedulesModuleBrand size={10} />,
  },
  service: {
    label: 'Cartas de Serviços',
    moduleName: 'SERVICE_LETTERS',
    moduleNameInAPI: 'SERVICE',
    href: SERVICES_LETTER_URL.split('.me')[1],
    Brand: <ServicesLetterModuleBrand size={10} />,
  },
  social_manager: {
    label: 'Gestor Social',
    moduleName: 'SOCIAL_MANAGER',
    moduleNameInAPI: 'SOCIAL_MANAGER',
    href: SOCIAL_MANAGER_URL.split('.me')[1],
    Brand: <SocialManagerModuleBrand size={10} />,
  },
  survey: {
    label: 'Avaliações e pesquisas',
    moduleName: 'SURVEY',
    moduleNameInAPI: 'RESEARCH',
    href: ASSESSMENTS_AND_RESEARCH_URL.split('.me')[1],
    Brand: <AssessmentsAndResearchModuleBrand size={10} />,
  },
  carehub: {
    label: 'Centro de cuidados',
    moduleName: 'CAREHUB',
    moduleNameInAPI: 'CAREHUB',
    href: CAREHUB_URL.split('.me')[1],
    Brand: <AssessmentsAndResearchModuleBrand size={10} />,
  },
}

function ModuleCard({ moduleSlug, showDefaultCard = false }: ModuleCardProps) {
  const { personalization } = usePersonalization()
  const { userPermissions } = useUserPermissionsManager()

  const moduleInfo = { ...modules[moduleSlug], ...personalization.license[moduleSlug] }

  const isActive = DEFAULT_MODULES_IN_THE_API.includes(moduleSlug)
    ? true
    : moduleInfo.status === 'ACTIVE'
    ? true
    : false
  const isAllowed = DEFAULT_MODULES_IN_THE_API.includes(moduleSlug)
    ? true
    : userPermissions.find(
        (element) =>
          element === `IMPACTO-${moduleInfo?.moduleNameInAPI}-ADMIN` ||
          element === `IMPACTO-${moduleInfo?.moduleNameInAPI}-ACCESS` ||
          element === 'IMPACTO-HEAVEN-GOD-ALL'
      )

  if (!moduleInfo.name) return null

  const ModuleCardContainer = () => {
    return (
      <Card
        id="module-card"
        height="100%"
        className="accessible"
        direction="row"
        overflow="hidden"
        gap={2}
        alignItems="center"
        borderWidth="2px"
        opacity={!isActive && !showDefaultCard ? 0.75 : 1}
        _hover={{ bg: 'lighterPrimary', borderColor: 'primary' }}
      >
        {!isActive && !showDefaultCard && <Lock position="absolute" right={2} top={2} />}
        {isActive && !isAllowed && !showDefaultCard && (
          <KeySimple variant="filled" color="red.500" position="absolute" right={2} top={2} />
        )}
        {moduleInfo?.Brand}
        <Heading size="xs">{moduleInfo?.name}</Heading>
      </Card>
    )
  }

  if (showDefaultCard) {
    return (
      <Box height="100%">
        <ModuleCardContainer />
      </Box>
    )
  }

  if (!isActive) {
    return <></>
    return (
      <Tooltip label="Módulo indisponível na instituição">
        <Box height="100%">
          <ModuleCardContainer />
        </Box>
      </Tooltip>
    )
  }

  if (!isAllowed) {
    return <></>
    return (
      <Tooltip label="Você não tem permissão para acessar o módulo">
        <Box height="100%">
          <ModuleCardContainer />
        </Box>
      </Tooltip>
    )
  }

  return (
    <Link
      rounded="md"
      href={moduleInfo?.href}
      _focus={{ '#module-card': { bg: 'lightPrimary' } }}
      _hover={{ textDecor: 'none' }}
      // isExternal={moduleInfo?.label === 'Processos e Documentos' ? true : false}
    >
      <Box height="100%">
        <ModuleCardContainer />
      </Box>
    </Link>
  )
}

export default memo(ModuleCard)
